module.exports = __webpack_public_path__ + "static/media/EditIcon_01.5bd283ec.svg";